{
  "version": 1,
  "asset_id": "a742ec2d-4210-43a0-9de5-c9eb9de5c354",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/a742ec2d-4210-43a0-9de5-c9eb9de5c354/hero-chart.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/a742ec2d-4210-43a0-9de5-c9eb9de5c354/hero-chart.jpg",
  "original_filename": "hero-chart.jpg",
  "size": 100373,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:37:56Z"
}
